var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("jade-box", [
    _c(
      "div",
      { staticClass: "flex flex-col gap-3 py-5" },
      [
        _c(
          "div",
          { staticClass: "px-5" },
          [
            _c(
              "jade-text",
              { attrs: { variant: "heading-xsmall", color: "high" } },
              [_vm._v(_vm._s(_vm.$t("transaction.data")))]
            ),
          ],
          1
        ),
        _c("jade-list-item", {
          attrs: {
            label: _vm.$t("transaction"),
            trailing: _vm.transactionId,
            compact: "",
          },
        }),
        _c("div", { staticClass: "px-5" }, [_c("jade-divider")], 1),
        _c("jade-list-item", {
          attrs: { label: _vm.$t("reason"), trailing: _vm.reason, compact: "" },
        }),
        _c("div", { staticClass: "px-5" }, [_c("jade-divider")], 1),
        _c("jade-list-item", {
          attrs: { label: _vm.$t("amount"), trailing: _vm.amount, compact: "" },
        }),
        _c("div", { staticClass: "px-5" }, [_c("jade-divider")], 1),
        _c("jade-list-item", {
          attrs: { label: "Status", compact: "" },
          scopedSlots: _vm._u([
            {
              key: "trailing",
              fn: function () {
                return [
                  _c("jade-display-item", {
                    attrs: {
                      alignment: "right",
                      value: {
                        variant: _vm.statusVariant,
                        text: _vm.statusLabel,
                      },
                    },
                  }),
                ]
              },
              proxy: true,
            },
          ]),
        }),
        _c("div", { staticClass: "px-5" }, [_c("jade-divider")], 1),
        _c("jade-list-item", {
          attrs: { label: _vm.$t("flag"), compact: "" },
          scopedSlots: _vm._u([
            {
              key: "trailing",
              fn: function () {
                return [_c("jade-brand", { attrs: { use: _vm.brandImage } })]
              },
              proxy: true,
            },
          ]),
        }),
        _c("div", { staticClass: "px-5" }, [_c("jade-divider")], 1),
        _c("jade-list-item", {
          attrs: {
            label: _vm.$t("credit-card-number"),
            trailing: _vm.creditCardNumber,
            compact: "",
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }